import {getCommunityUserModal} from "../modal/getCommunityUserModal";

export function renameTimelineTypeHtml(tempShopUserId, container) {
    $.ajax({
        type: "POST",
        url: "/module/community/ajax.php?action=get_community_user_by_shop_user_id",
        datatype: "json",
        data: {
            "ajax_call_shop_user_id": tempShopUserId
        },
        success: function (output) {
            var data = $.parseJSON(output);
            var textContainer = container.find(".js-comment-type");
            var oldText = textContainer.text().replace(/\n/g, "").trim().split(" ");
            var link = "/" + siteCode + "/" + mainLanguageCode + "/stammtisch/profile/" + data.nickname_slug + "/";
            var newText = "";
            $.each(oldText, function (key, value) {
                if (key < oldText.length - 1) {
                    newText += value + " ";
                }
            });
            newText += "von <a href='" + link + "' class='name user-post-profile-link' target='_blank'>" + data.nickname + "</a> " + oldText[oldText.length - 1];
            textContainer.html(newText);
            container.find('.js-comment-type a').on('click', function (e) {
                e.preventDefault();

                    var link = $(this).attr("href");
                    var linkArray = link.split("/");
                    var nickname = linkArray[linkArray.length - 2];
                    var modal = $("#community_user_profile_modal_" + nickname);
                    if (modal.length) {
                        modal.modal("show");
                    } else {
                        getCommunityUserModal(nickname);
                    }

            })
        }
    });
}